<template>
  <full-container :padding="0">
    <el-tree ref="moduleTree" :data="datalist" :props="{ label: 'Title', children: 'children' }" node-key="Id" show-checkbox default-expand-all />
    <el-button slot="footer" size="small" type="primary" icon="el-icon-s-promotion" @click="onSubmit">保存授权</el-button>
  </full-container>
</template>

<script>
export default {
  props: {
    mode: { type: Number, default: null },
    target: { type: String, default: null },
  },
  data () {
    return {
      loading: false,
      authorizes: [],
      datalist: [],
      buttons: [],
    }
  },
  created () {
    //先获取到权限
    this.$apis.system.authorize.getList({
      mode: this.mode,
      targets: [this.target],
      types: [2],
    }).then((res) => {
      this.authorizes = res
      this.initModules()
    }).catch((e) => {
      this.$message.error(e)
    })
  },
  methods: {
    //模块信息
    initModules () {
      this.loading = true
      this.$apis.system.menu.getTree({
        parentId: null,
      }).then((res) => {
        this.datalist = res
      }).then(() => {
        //解决Tree半选中状态回显
        this.authorizes.map((id) => {
          let node = this.$refs['moduleTree'].getNode(id)
          if (node.isLeaf) {
            this.$refs['moduleTree'].setChecked(node, true)
          }
        })
      }).catch(e => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    //提交
    onSubmit () {
      this.$confirm('此操作将重新设置角色权限, 是否继续?', '提示', {
        center: true,
      }).then(() => {
        this.loading = true
        let keys = [
          ...this.$refs['moduleTree'].getHalfCheckedKeys(),
          ...this.$refs['moduleTree'].getCheckedKeys(false)
        ]
        this.$apis.system.authorize
          .submit({
            Type: 2,
            Mode: this.mode,
            Target: this.target,
            Inserts: [...keys].filter((x) =>
              [...this.authorizes].every((y) => y !== x)
            ),
            Removes: [...this.authorizes].filter((x) =>
              [...keys].every((y) => y !== x)
            ),
          })
          .then(() => {
            this.authorizes = keys
            this.$message({ message: '设置成功！', type: 'success', })
          }).catch((e) => {
            this.$message.error(e)
          }).finally(() => {
            this.loading = false
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.el-tree-node__content) {
  height: 32px;
}
</style>
